import { render, staticRenderFns } from "./ui-layout.component.vue?vue&type=template&id=726c53fc&"
import script from "./ui-layout.component.vue?vue&type=script&lang=ts&"
export * from "./ui-layout.component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-layout.component.vue?vue&type=style&index=0&id=726c53fc&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports